// extracted by mini-css-extract-plugin
export default {"component":"styles__component--o9zyl","inner":"styles__inner--jc4NJ"};